import { render } from "./StaticFormManager.vue?vue&type=template&id=3a5f6ff7"
import script from "./StaticFormManager.vue?vue&type=script&lang=js"
export * from "./StaticFormManager.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__